import React from "react";
import HOC from "../../components/HOC";
import DiscountComponents from "../../components/screen/discount/Discount";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const Discount = () => {
  return (
    <div className="">
      <PageTemplate
        header="Discount & Promo"
        mainComponent={<DiscountComponents />}
        checkOwner={true}
      />
    </div>
  );
};

export default HOC(Discount);
